import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TokenStorage } from './core/token-storage';
import { NavTopBarComponent } from './components/core/nav-top-bar/nav-top-bar.component';
import { UsersService } from './services/users.service';
import { NavMenuComponent } from './components/core/nav-menu/nav-menu.component';
import { ThemesService } from './services/themes.service';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
    NavTopBarComponent,
    NavMenuComponent,
    MatSidenav,
    MatSidenavContainer,
  ],
})
export class AppComponent implements OnInit {
  title = 'NexusFront';
  showNav = true;
  isAuthenticated = false;   // ajout

  constructor(
    private tokenStorage: TokenStorage,
    private usersService: UsersService,
    private themesService: ThemesService,
    private router: Router
  ) {}

  ngOnInit() {
    this.themesService.changeTheme(this.themesService.getCurrentTheme());

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('__access_token__');

    if (token) {
      console.log('Token reçu depuis l’URL :', token);
      this.tokenStorage.saveToken(token);

      this.usersService.getCurrentUser().subscribe({
        next: (user) => {
          console.log('Utilisateur récupéré :', user);
          sessionStorage.setItem('user', JSON.stringify(user));
          console.log('Utilisateur sauvegardé dans sessionStorage.');
          this.isAuthenticated = true; // connecté
        },
        error: (err) => {
          console.error('Erreur lors de la récupération de l’utilisateur :', err);
          this.isAuthenticated = false; // pas connecté
        },
      });
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const hiddenRoutes = ['/login'];
        this.showNav = !hiddenRoutes.includes(event.urlAfterRedirects);
        this.isAuthenticated = !!this.tokenStorage.getToken(); // check token
      });
  }
}
